import { gridAggregationLookupSelector } from "@mui/x-data-grid-premium";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import AppStore from "@stores/AppStore";
import { MutableRefObject } from "react";
import { parseMultiplier } from "./multiplier";

export const setSelectedNodesKeys = (
  apiRef: MutableRefObject<GridApiPremium>,
  appStore: AppStore) => {
  const selectedModelCategories: any = {};
  const selectedRows = apiRef.current.getSelectedRows();
  const aggregationLookup = gridAggregationLookupSelector(apiRef);

  selectedRows.values().forEach((value: any) => {
    if (value.field === "cadModelCategoryId") {
      value.aggregations = aggregationLookup[value.id];
      selectedModelCategories[value.rawValue] = value;
    }
  });

  // TODO: this could be computed on-demand instead of stored in the AppStore
  appStore.setSelectedModelCategories(selectedModelCategories);
};

export const validateModelRow = (row: any) => {
  const errors: Record<string, string> = {};

  // Notes: max 250 chars
  if (row?.data?.notes && row.data.notes.length > 250) {
    errors.notes = "Notes cannot exceed 250 characters.";
  }

  // Multiplier: must be empty or parseable
  const input = row?.data?.multiplierInput ?? "";
  const parsed = parseMultiplier(input);
  if (input.trim() !== "" && parsed === null) {
    errors.multiplierInput = "Invalid multiplier. Use %, number, or formula.";
  }

  // Carbon Impact: must be empty or parseable (same rules as multiplier)
  const carbonInput = row?.data?.carbonImpactInput ?? "";
  const parsedCarbon = parseMultiplier(carbonInput);
  if (carbonInput.trim() !== "" && parsedCarbon === null) {
    errors.carbonImpactInput = "Invalid carbon impact. Use %, number, or formula.";
  }
  // CarbonImpactNotes: max 250 chars
  if (row?.data?.carbonImpactNotes && row.data.carbonImpactNotes.length > 250) {
    errors.carbonImpactNotes = "Notes cannot exceed 250 characters.";
  }

  return errors;
};